module.exports = __webpack_public_path__ + "img/web2.947f52da.png";